// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 125) return "static/chunks/125-ea48b69a503c0af8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"85":"38367f19","146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal"}[chunkId] || chunkId) + "." + {"85":"e1d3b31fdb0f9b06","146":"983a867c9094c2be","298":"3c17f9a45cf5b456","340":"065e24a5923b9abb","367":"5040e60c38bf6319","432":"fe519466e301961f","695":"7781d3868a3e0785"}[chunkId] + ".js";
};